import { render, staticRenderFns } from "./ProductOrders.vue?vue&type=template&id=568763ac&scoped=true"
import script from "./ProductOrders.vue?vue&type=script&lang=js"
export * from "./ProductOrders.vue?vue&type=script&lang=js"
import style0 from "./ProductOrders.vue?vue&type=style&index=0&id=568763ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568763ac",
  null
  
)

export default component.exports